import React, { useRef } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import './Card.css'

const Card = props => {
    const { name, stars, photos, pricing, dispatch, location, id } = props;
    const handleClick = (evt, listing) => {
        dispatch.homes.clickedListing(listing)
    }
    const onHover = (evt, { location, id} ) => {
        const { lng, lat } = location
        dispatch.locations.onListingHover({ id: id, coordinates: [lng,lat] })
    }
    return (
        <Link
            to={`/rooms`}
            style={{ textDecoration: 'none', color: 'inherit' }}
        >
            <div className='card' onClick={ evt => handleClick(evt, props) } onMouseEnter={  evt => onHover(evt, ({ location, id })) }>
                <img src={ photos[0].large } className='card-image'/>
                <div className='card-stats'>
                    <span className='grey' style={{ paddingRight: '10px' }}>{ stars } stars</span>
                    <span className='grey'>{ pricing.rate.amount_formatted } { pricing.rate.currency }</span>
                    <span className='grey'></span>
                </div>
                <p>{ name }</p>
                <p><span className='bold'></span></p>
            </div>
        </Link>
    )
}

const mapStateToProps = () => (
    dispatch => ({
        homesSelect: dispatch.homes,
        locationsDispatch: dispatch.locations
    })
);

export default connect(mapStateToProps())(Card);
